import { LeanToSettingConfig } from "./LeanToSettingConfig";
import { LeanToWraparoundSetting } from "./LeanToWraparoundSetting";
import { SignalConfig } from "./SignalConfig";
import { Collection } from "../utils/Collection";

export class LeanToConfig
{
	public label : string;

	public back  : LeanToSettingConfig;
	public front : LeanToSettingConfig;
	public left  : LeanToSettingConfig;
	public right : LeanToSettingConfig;

	public wraparound_front_left  : LeanToWraparoundSetting;
	public wraparound_front_right : LeanToWraparoundSetting;
	public wraparound_back_left   : LeanToWraparoundSetting;
	public wraparound_back_right  : LeanToWraparoundSetting;

	public wall : SignalConfig<boolean>;

	public fields : any;

	constructor(setting)
	{
		this.label = setting.label;

		this.back  = new LeanToSettingConfig(setting);
		this.front = new LeanToSettingConfig(setting);
		this.left  = new LeanToSettingConfig(setting);
		this.right = new LeanToSettingConfig(setting);

		this.createWraparounds();

		this.left.setWraparoundSettings(this.wraparound_back_left, this.wraparound_front_left);
		this.right.setWraparoundSettings(this.wraparound_front_right, this.wraparound_back_right);
		this.front.setWraparoundSettings(this.wraparound_front_left, this.wraparound_front_right);
		this.back.setWraparoundSettings(this.wraparound_back_right, this.wraparound_back_left);

		this.fields = new Collection(setting.fields, "id");
		this.wall   = new SignalConfig<boolean>({value: this.fields.getByKey("wall").value === "on"});
	}

	private createWraparounds()
	{
		var wraparounds = LeanToWraparoundSetting.CONFIGS;

		for (var i = 0; i < wraparounds.length; i++)
		{
			var vertical   = wraparounds[i].vertical;
			var horizontal = wraparounds[i].horizontal;
			var propertyName = "wraparound_" + vertical + "_" + horizontal;

			this[propertyName] = new LeanToWraparoundSetting({
				vertical: vertical,
				horizontal: horizontal,
				verticalLeanTo: this[vertical],
				horizontalLeanTo: this[horizontal]
			});
		}
	}

	/*public addExternalListeners()
	{
		this["wraparound_back_left"].addExternalListener(Main.getInstance().config.building.insetBay.back.count);
		this["wraparound_back_right"].addExternalListener(Main.getInstance().config.building.insetBay.back.count);
		this["wraparound_front_left"].addExternalListener(Main.getInstance().config.building.insetBay.front.count);
		this["wraparound_front_right"].addExternalListener(Main.getInstance().config.building.insetBay.front.count);
	}*/
}